/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerFindAllQueryResponse, ApplicationSourcesControllerFindAllQueryParams, ApplicationSourcesControllerFindAll401, ApplicationSourcesControllerFindAll403 } from "../../models/checklistsController/ApplicationSourcesControllerFindAll";

function getApplicationSourcesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-application-sources` as const }  
  return res
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist application sources
 * {@link /api/v1/checklist-application-sources}
 */
export async function applicationSourcesControllerFindAll(params?: ApplicationSourcesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSourcesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindAll401 | ApplicationSourcesControllerFindAll403>, unknown>({ method : "GET", url : getApplicationSourcesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}